import React, { useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import MenuIcon from '../Assets/Images/header-menu-icon.svg';
import Logo from '../Assets/Images/six-logo.svg';
import { PageNames, PageDisplayNames } from "../Assets/variables";

export default function Layout() {
    const [isSidebarShown, setIsSidebarShown] = useState(true);
    const [isWebAPIShown, setIsWebAPIShown] = useState(true);
    const [isBulkAPIShown, setIsBulkAPIShown] = useState(true);
    const [activePage, setActivePage] = useState('');

    const toggler = (stateFunction, variable) => {
        stateFunction(!variable);
    }

    const sidebarToggler = (isShown = true) => {
        setIsSidebarShown(isShown);
    };

    const setActivePageItem = (pageName = '') => {
        setActivePage(pageName);
    }

    return (
        <>
            <div className="header">
                <button id="header-menu-button" type="button" onClick={() => toggler(setIsSidebarShown, isSidebarShown)}>
                    <img src={MenuIcon} alt="Main menu button" />
                </button>
                <Link id="header-home-button" to={"home"}>
                    <img className="header__logo" src={Logo} alt="API Portal Home button" />
                    <span>API</span>
                </Link>
            </div>
            <section className={"content-row " + (isSidebarShown ? "shown" : "hidden")}>
                <div id="sidebar">
                    <div className="button-group">
                        <Link
                            className={"sidebar__button " + (activePage === PageNames.Catalog ? "sidebar__button--active" : "")}
                            to={PageNames.Catalog}>
                                {PageDisplayNames.Catalog}
                        </Link>
                    </div>
                    <div className="button-group">
                        <button id="web-api-button" className={"sidebar__accordion--main " + (isWebAPIShown ? "shown" : "not-shown")} onClick={() => toggler(setIsWebAPIShown, isWebAPIShown)}>Web API</button>
                        <div id="web-api" className={isWebAPIShown ? "shown" : "hidden"}>
                            <Link
                                to={"https://www.six-api-portal.online/portfolio"}
                                target="_blank"
                                className="sidebar__sub-button-with-icon">
                                <span>{PageDisplayNames.Showcase}</span>
                                <span className="material-icons-outlined icon">launch</span>
                            </Link>
                            <Link
                                to={PageNames.GraphQLExplorer}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.GraphQLExplorer ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.GraphQLExplorer}
                            </Link>
                            <Link
                                to={PageNames.Documentation}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.Documentation ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.Documentation}
                            </Link>
                            {/* <Link
                                to={PageNames.MarketsList}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.MarketsList ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.MarketsList}
                            </Link> */}
                            <Link
                                to={PageNames.ReleaseNotes}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.ReleaseNotes ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.ReleaseNotes}
                            </Link>
                            <Link
                                to={PageNames.DataDictionary}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.DataDictionary ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.DataDictionary}
                            </Link>
                        </div>
                    </div>
                    <div className="button-group">
                        <button id="bulk-api-button" className={"sidebar__accordion--main " + (isBulkAPIShown ? "shown" : "not-shown")} onClick={() => toggler(setIsBulkAPIShown, isBulkAPIShown)}>Bulk API</button>
                        <div id="bulk-api" className={isBulkAPIShown ? "shown" : "hidden"}>
                            <Link
                                to={PageNames.BulkAPIDocumentation}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.BulkAPIDocumentation ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.Documentation}
                            </Link>
                            <Link
                                to={PageNames.BulkAPIDataDictionary}
                                className={"sidebar__button sidebar__button--sub-item " + (activePage === PageNames.BulkAPIDataDictionary ? "sidebar__button--active" : "")}>
                                    {PageDisplayNames.DataDictionary}
                            </Link>
                        </div>
                    </div>    
                    <Link to={"https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html"} target="_blank" className="sidebar__button-with-icon">
                        <span>Contact Us</span>
                        <span className="material-icons-outlined icon">launch</span>
                    </Link>
                </div>
                <main className="content">
                    <Outlet context={{sidebarToggler, setActivePageItem}} />
                </main>
            </section>
        </>
    )
}